import { atom } from "jotai";
import { Table } from "../entities/Table";

export const selectedIdfromTableRowTransaction = atom("");

export const selectedTableCardInfo = atom<Table>({
  _id: "",
  name: "",
  tableCode: "",
  percents: 0,
  bonus: 0,
  isActive: true,
  createdAt: "",
  updatedAt: "",
});
export const currentStep = atom(0);

export const userIdentity = atom({
  id: "",
  name: "",
  email: "",
});

export const crefazProposalDataAtom = atom<{
  cpf: string;
  zipcode?: string;
  shouldOpenModal: boolean;
} | null>(null);
